import i18n from '../../../../../base-dictionary';
import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { useSearchedTasks } from '../related-tasks-tab.hooks';
import { RelatedTasksMode } from '../related-tasks-tab.type';

/**
 * Hook that determines placeholder data to display based on current mode and data state
 *
 * @returns {Object|null} Placeholder configuration object or null if no placeholder needed
 * @returns {string} returns.icon - Material icon name to display
 * @returns {string} returns.text - Text message to display
 */
const usePlaceholderData = (): {
  icon: string;
  text: string;
} | null => {
  const tasks = useSearchedTasks();
  const mode = useRelatedTasksTabStore((state) => state.mode);
  const selectedEpic = useRelatedTasksTabStore((state) => state.selectedEpic);
  const selectedTeam = useRelatedTasksTabStore((state) => state.selectedTeam);

  if (tasks.length === 0) {
    if (
      (mode === RelatedTasksMode.ContributingEpics && selectedEpic) ||
      (mode === RelatedTasksMode.ContributingTeams && selectedTeam)
    ) {
      return {
        icon: 'event_busy',
        text: i18n.t('strategy.initiative_performance.no_tasks_data_for_month'),
      };
    }

    return {
      icon: 'mobiledata_off',
      text: i18n.t('strategy.initiative_performance.no_filtered_data'),
    };
  }

  return null;
};

export { usePlaceholderData };
